import { cpfValido } from '@acme/common'
import Grid from '@/global/components/ui/Grid'
import {
    FormDatePicker,
    FormField,
    FormFieldSelect,
} from 'global/components/Form'
import { useFormContext } from 'react-hook-form'

export function Documentos() {
    const { setError, clearErrors, getValues } = useFormContext()
    return (
        <section id="documentos">
            <Grid container columns={24}>
                <Grid item xs={24}>
                    <FormField required name="nome" label="Nome" />
                </Grid>
                <Grid item xs={6}>
                    <FormField
                        required
                        name="cpf"
                        label="CPF"
                        options={{
                            blocks: [3, 3, 3, 2],
                            delimiters: ['.', '.', '-'],
                            numericOnly: true,
                        }}
                        defaultValue={''}
                        onBlur={() => {
                            const cpfValue = getValues('cpf')
                            if (!cpfValido(cpfValue)) {
                                setError('cpf', { message: 'CPF inválido' })
                            } else {
                                clearErrors('cpf')
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormField
                        required
                        name="pis"
                        label="PIS"
                        options={{
                            blocks: [3, 5, 2, 1],
                            delimiters: ['.', '.', '-'],
                            numericOnly: true,
                        }}
                    />
                </Grid>
                <Grid item xs={5}>
                    <FormFieldSelect
                        name="sexo"
                        label="Sexo"
                        defaultValue="M"
                        options={[
                            { value: 'M', label: 'Masc.' },
                            { value: 'F', label: 'Fem.' },
                        ]}
                    />
                </Grid>
                <Grid item xs={7}>
                    <FormDatePicker
                        name="dtNascimento"
                        label="Data de nascimento"
                        type="date"
                    />
                </Grid>
            </Grid>
        </section>
    )
}
